module.exports = __webpack_public_path__ + "static/media/mail.894ecd08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/homepage/mail.png
// module id = 1513
// module chunks = 0